<section class="bg-half-260 bg-primary d-table w-100" id="home"
         style="background-size:cover; background-image:url('assets/3r/cover/people-2557396_640.jpg');">
    <div class="bg-overlay"></div>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="title-heading text-center mt-4">
                    <h1 class="display-4 title-dark font-weight-bold text-white mb-3">PRE AND POST DEPARTURE
                        ASSISTANCE</h1>
                    <!--                    <p class="para-desc mx-auto text-white-50">{{detail.description}}</p>-->
                    <!--                    <div class="mt-4 pt-2">-->
                    <!--                        <a href="javascript:void(0)" class="btn btn-primary"><i class="mdi mdi-email"></i> Get-->
                    <!--                            Started</a>-->
                    <!--                    </div>-->
                </div>
            </div>
            <!--end col-->
        </div>
        <!--end row-->
    </div>
    <!--end container-->

</section>

<div class="container mt-100 mt-60 mb-5">
    <div class="row ">
        <div class="col-12 ">
            <div class="section-title mb-4 pb-2">
                <h3 class="title mb-4 mt">PRE DEPARTURE BRIEFINGS</h3>
                <p class="text-muted   mb-0">
                    3R International overseas education organizes pre and post departure get together for its students
                    giving them an opportunity to meet others heading towards the same University or Country.
                </p>
            </div>
        </div>
        <!--end col-->
    </div>

    <div class="row align-items-center">
        <div class="col-12 ">
            <div class="section-title mb-4 pb-2">
                <h5 class=" mb-4 mt">POST ARRIVAL PROBLEM SOLVING</h5>
                <p class="text-muted   mb-0">
                    We are constantly in touch with the Universities/ Colleges to ensure that our students do not face
                    any problem related to accommodation, course, etc and hence provide enough support to them in their
                    early stages in a new country when things would be new and unfamiliar.
                    <br><br>
                    Our specialist counselors, each with their own areas of expertise, provide extensive personal
                    guidance on all aspects of overseas education, including the choice of schools and colleges,
                    educational planning, sixth-form options, university entry, postgraduate studies, and professional
                    training, as well as any educational issues which may be causing concern.
                    <br><br>
                    Counseling takes place by appointment in our offices or by telephone for those unable to visit.
                    Afterwards our counselor will send you a report of the discussion, together with any
                    recommendations, and will be happy to answer any query.
                </p>
            </div>
        </div>
        <!--end col-->
    </div>

    <div class="row align-items-center">
        <div class="col-12 ">
            <div class="section-title mb-4 pb-2">
                <h5 class=" mb-4 mt">VISIT VISA GUIDANCE FOR ALL COUNTRIES</h5>
                <p class="text-muted   mb-0">
                    3R International has excellent relationships with Embassies and High Commissions worldwide. Our
                    professional consultants will also provide visit visa guidance for all countries. With the help of
                    our knowledgeable visa consultants, you can be sure that you fulfill all the necessary visa
                    conditions and requirements with ease. Our counsellors will also carefully review the documents and
                    check if everything is in order before submitting them.
                </p>
            </div>
        </div>
        <!--end col-->
    </div>


</div>
